module.exports = __webpack_public_path__ + "static/media/dine_image2.620500e8.png";